import { useRouter } from "next/router";
import { type RefObject, useEffect, useRef } from "react";

export function useScrollTopOnNavigation(): RefObject<HTMLDivElement | null> {
  const containerRef = useRef<null | HTMLDivElement>(null);
  const { asPath } = useRouter();
  const pathNoParams = asPath.split("?")[0];
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional to scroll to top of container on path change
  useEffect(() => {
    if (containerRef.current !== null) {
      containerRef.current.scroll(0, 0);
    }
  }, [pathNoParams]);
  return containerRef;
}
